import tw from 'tailwind-styled-components'

export const AgendaAsideContainer = tw.div`
    flex
    flex-col
    gap-8
    col-span-3
    h-full
`
